import { render } from "./attend.vue?vue&type=template&id=72d8027b"
import script from "./attend.vue?vue&type=script&lang=js"
export * from "./attend.vue?vue&type=script&lang=js"

import "./attend.vue?vue&type=style&index=0&id=72d8027b&lang=css"

import exportComponent from "/home/chris/tw/src/attendctrl/attend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__